import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TrabalheConoscoComponent } from './trabalhe-conosco.component';
import { TrabalheConoscoRoutingModule } from './trabalhe-conosco.routes';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '@app/shared/shared.module';
import { TrabalheConoscoService } from './trabalhe-conosco.service';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [TrabalheConoscoComponent],
  imports: [
    CommonModule,
    TrabalheConoscoRoutingModule,
    MatButtonModule,
    MatCardModule,
    MatInputModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    FormsModule,
    SharedModule,
    MatIconModule,
  ],
  exports: [],
  providers: [TrabalheConoscoService],
})
export class TrabalheConoscoModule {}
